import React, { useRef } from 'react'
import ariesImage from "../assets/AiImage/aries.png";
import taurusImage from "../assets/AiImage/taurus1.png";
import geminiImage from "../assets/AiImage/gemini1.png";
import cancerImage from "../assets/AiImage/cancer.png";
import leoImage from "../assets/AiImage/leo.png";
import virgoImage from "../assets/AiImage/virgo.png";
import libraImage from "../assets/AiImage/libra.png";
import scorpioImage from "../assets/AiImage/scorpio.png";
import sagittariusImage from "../assets/AiImage/Sagittarius.png";
import capricornImage from "../assets/AiImage/Capricorn.png";
import aquariusImage from "../assets/AiImage/aquarius1.png";
import piscesImage from "../assets/AiImage/pisces1.png";
import career from "../assets/extraimage/career.jpg";
import lover from "../assets/extraimage/lover.jpg";
import yesno from "../assets/extraimage/yesno.jpg";
import kundli from "../assets/extraimage/kundli.jpg";
import compatibility from "../assets/extraimage/compatibility.jpg";
import horoscope from "../assets/extraimage/horoscope.jpg";
import zodiachoroscope from "../assets/extraimage/zodiachoroscope.jpg";
import { FaChevronLeft, FaChevronRight, FaHome } from 'react-icons/fa';
import astrology from "../assets/tarotpageImage/astroimg.jpg"
import Navbar from '../home/Navbar';
import { Link, useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import Queryform from './Queryform';
import Footer from '../home/Footer';
const LoveCompatibilityResult = () => {
   const zodiacSigns = [
           { sign: 'Aries', image: ariesImage },
           { sign: 'Taurus', image: taurusImage },
           { sign: 'Gemini', image: geminiImage },
           { sign: 'Cancer', image: cancerImage },
           { sign: 'Leo', image: leoImage },
           { sign: 'Virgo', image: virgoImage },
           { sign: 'Libra', image: libraImage },
           { sign: 'Scorpio', image: scorpioImage },
           { sign: 'Sagittarius', image: sagittariusImage },
           { sign: 'Capricorn', image: capricornImage },
           { sign: 'Aquarius', image: aquariusImage },
           { sign: 'Pisces', image: piscesImage },
       ];
    const reports = [
        { title: 'Love Tarot Reading', image: lover, link: '/love/tarot' },
        { title: 'Career Tarot', image: career, link: '/daily/tarot' },
        { title: 'Compatibility', image: compatibility, link: '/compatibility' },
        { title: 'Yes/No Reading', image: yesno, link: '/daily/tarot' },
        { title: 'Horoscope', image: horoscope, link: '/horoscope' },
        { title: 'Zodiac Horoscope', image: zodiachoroscope, link: '/horoscope' },
        { title: 'Free Kundli', image: kundli, link: '/new-kundli' }
    ];

    const navigate = useNavigate();
    const scrollContainer = useRef(null);

    const scrollLeft = () => {
        scrollContainer.current.scrollBy({ left: -200, behavior: 'smooth' });
    };

    const scrollRight = () => {
        scrollContainer.current.scrollBy({ left: 200, behavior: 'smooth' });
    };

    const handleReportClick = (link) => {
        navigate(link);
    };

    const location = useLocation();
    const { prediction, yourSign, partnerSign } = location.state || {};  // Extract passed data
    const getImageForSign = (sign) => {
        const zodiac = zodiacSigns.find((z) => z.sign === sign);
        return zodiac ? zodiac.image : null;
    };

    return (
        <>
            <section className="bg-gradient-to-r from-white to-success/40  text-gray-900 min-h-screen">
                <Navbar />
                <div className="min-h-screen flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
                    {/* Main Container */}
                    <div className="bg-white rounded-lg shadow-lg p-8 max-w-5xl w-full">
                        {/* Header Section */}
                        <h1 className="text-3xl font-bold text-center bg-gradient-to-r from-success to-[#9034E9] text-white p-2 rounded-md mb-8">
                            Love Compatibility for {yourSign} and {partnerSign}
                        </h1>

                        {/* Compatibility Content */}
                        <div className="flex sm:flex-row justify-center items-center mb-6">
                            {/* Your Sign */}
                            <div className="flex flex-col items-center mb-6 sm:mb-0 p-4">
                                <h2 className="text-xl font-semibold text-secondary">Your Sign</h2>
                                <div className="w-28 h-28 bg-gray-300 rounded-full flex items-center justify-center mt-2 mb-4">
                                    <img src={getImageForSign(yourSign)} alt={yourSign} className="w-24 h-28 lg:w-28 lg:h-32 md:w-28 md:h-32 sm:w-24 sm:h-28 object-cover ring-4 shadow-md shadow-gray-500 rounded-full" />
                                </div>
                                <p className="text-lg text-white bg-secondary rounded-full px-4 py-1">{yourSign}</p>
                            </div>

                            {/* Plus Icon */}
                            <div className="mb-6 sm:mb-0">
                                <h2 className="text-3xl font-semibold text-gray-800">+</h2>
                            </div>

                            {/* Partner's Sign div section */}
                            <div className="flex flex-col items-center mb-6 sm:mb-0 rounded-sm p-4">
                                <h2 className="text-xl font-semibold text-secondary">Partner Sign</h2>
                                <div className="w-28 h-28 bg-gray-300 rounded-full flex items-center justify-center mt-2 mb-4">
                                    <img src={getImageForSign(partnerSign)} alt={partnerSign} className="w-24 h-28 lg:w-28 lg:h-32 md:w-28 md:h-32 sm:w-24 sm:h-28 object-cover ring-4 shadow-md shadow-gray-500 rounded-full" />
                                </div>
                                <p className="text-lg text-white bg-secondary rounded-full px-4 py-1">{partnerSign}</p>
                            </div>
                        </div>

                        {/* Description Section */}
                        <div className="text-gray-900 bg-slate-100 rounded-md p-3 text-justify mb-8">
                            <p className="mt-4 text-base">{prediction}</p>
                        </div>

                        {/* Button */}
                        <div className="flex justify-center">
                            <button onClick={() => window.history.back()}
                                className="bg-gray-900 hover:bg-success tranistion duration-300 text-white font-bold py-2 px-20 rounded-full">
                                Try Another Match
                            </button>
                        </div>
                    </div>
                </div>
                <main className="mt-4 px-4 sm:px-12 md:px-20 lg:px-44">
                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-10">

                        {/* Main Content Section */}
                        <div className="text-justify lg:w-2/3 mt-2">
                            <div className="text-gray-800 w-full rounded-lg">
                                <h2 className="text-xl sm:text-2xl font-bold pt-3">
                                    About Chinese Compatibility
                                </h2>
                                <p className="text-sm sm:text-base md:text-lg">
                                    How well do your Chinese Zodiac signs align in work, relationships, and friendships? Each sign in the Chinese Zodiac carries distinct personality traits, strengths, and challenges, influencing how individuals interact with one another. Whether you're a dynamic Dragon working alongside a diligent Ox or a passionate Tiger collaborating with a resourceful Rat, understanding your zodiac compatibility can reveal whether you're a powerful team or a challenging match. Some pairs naturally complement each other, fostering harmony and success, while others may face obstacles due to differing temperaments. By exploring the elemental influences of your sign—Wood, Fire, Earth, Metal, or Water—you can uncover deeper insights into how you connect, communicate, and thrive with others. Find out if you and your partner, colleague, or friend form a fierce duo destined for success or a prickly mismatch needing balance and compromise!
                                </p>

                                {/* Recommended Reports Section */}
                                <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
                                    <h2 className="text-lg sm:text-2xl font-bold pt-3 text-start mb-4">
                                        Recommended Reports For You
                                    </h2>
                                    <div className="flex space-x-2">
                                        <button onClick={scrollLeft} className="p-2">
                                            <FaChevronLeft className="text-gray-600 hover:text-gray-800" size={20} />
                                        </button>
                                        <button onClick={scrollRight} className="p-2">
                                            <FaChevronRight className="text-gray-600 hover:text-gray-800" size={20} />
                                        </button>
                                    </div>
                                </div>

                                {/* Cards Section (Scrollable Reports) */}
                                <div className="flex items-center">
                                    <div ref={scrollContainer} className="flex overflow-x-hidden space-x-4 scrollbar-hide w-full">
                                        {reports.map((report, index) => (
                                            <div
                                                key={index}
                                                className="flex-shrink-0 w-40 sm:w-48 p-4 bg-gray-200 rounded-lg shadow border-2 border-secondary hover:bg-secondary/35 cursor-pointer"
                                                onClick={() => handleReportClick(report.link)}
                                            >
                                                <div className="w-full h-28 sm:h-32 bg-gray-300 flex items-center justify-center rounded-md mb-2">
                                                    <img
                                                        src={report.image}
                                                        alt={report.title}
                                                        className="w-full h-full object-cover rounded-md"
                                                    />
                                                </div>
                                                <h3 className="text-center font-semibold text-sm sm:text-base">{report.title}</h3>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Advertisement Section */}
                        <div className="w-full sm:w-auto">
                            <div className="bg-white mt-10 sm:mt-16 md:mt-20 text-primary rounded-lg shadow-lg max-w-sm mx-auto lg:mx-0">
                                <div className="flex justify-center">
                                    <img
                                        src={astrology}
                                        alt="Astrology placeholder"
                                        className="w-full h-36 sm:h-48 bg-[#01010d] object-contain"
                                    />
                                </div>
                                <h2 className="text-2xl sm:text-3xl font-bold mt-2 text-center">AstroTellers</h2>
                                <div className="text-center">
                                    <p className="text-lg sm:text-2xl">Your Personalized</p>
                                    <p className="text-lg sm:text-2xl -mt-2">Cosmic Membership</p>
                                </div>
                                <p className="mx-4 text-center text-xs sm:text-sm mt-2 mb-2">
                                    Daily, weekly, monthly, and yearly personalized astrological guidance at your fingertips.
                                </p>
                                <div className="text-center">
                                    <button className="bg-primary text-white py-2 px-4 mb-4 rounded-lg hover:bg-success hover:shadow-xl transition duration-300">
                                        Join Astrology Plus
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Queryform />
                <Footer />
            </section>
        </>
    )
}

export default LoveCompatibilityResult